import theme from '@/theme';

export const searchbarInputContainerStyle = {
  [theme.breakpoints.down('xxl')]: {
    width: '30%'
  },
  [theme.breakpoints.down('xl')]: {
    width: '45%'
  },
  [theme.breakpoints.down('lg')]: {
    width: '70%'
  },
  display: 'flex',
  minWidth: '26vw'
};
